module.exports = __webpack_public_path__ + "static/the-magus-dc78d483db9df5ed0abde47dc48df8b2.jpg";